import React, { useMemo, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { MenuItem } from '@material-ui/core';

import {
    fetchRecordingOutputsRequest,
    generateRecordingOutputsRequest,
} from 'Console/data/applicationDetail/guides/recording/RecordingAction';

import { selectAppId } from 'Console/data/applicationDetail/settings/SettingsSelector';

import {
    makeSelectOutputAssetsArray,
    makeSelectOutputAssetId,
    makeSelectOutputAssetAddonSystemKey,
    makeSelectOutputAssetRepositoryId,
} from 'Console/data/applicationDetail/guides/recording/selectors';

const GuideListItemRecordingMenuItems = ({ guide, onClose }): React.ReactElement => {
    const dispatch = useDispatch();
    const guideId = guide.id;

    const selectOutputAssetsArray = useMemo(makeSelectOutputAssetsArray, []);
    const selectOutputAssetId = useMemo(makeSelectOutputAssetId, []);
    const selectOutputAssetAddonSystemKey = useMemo(makeSelectOutputAssetAddonSystemKey, []);
    const selectOutputAssetRepositoryId = useMemo(makeSelectOutputAssetRepositoryId, []);

    const applicationId = useSelector(selectAppId);
    const assetsArray = useSelector((state) => selectOutputAssetsArray(state, guideId));
    const assetId = useSelector((state) => selectOutputAssetId(state, guideId));
    const addonSystemKey = useSelector((state) => selectOutputAssetAddonSystemKey(state, guideId));
    const repositoryId = useSelector((state) => selectOutputAssetRepositoryId(state, guideId));

    const handleDownloadRecording = useCallback(() => {
        dispatch(
            fetchRecordingOutputsRequest(applicationId, guideId, assetId, addonSystemKey, repositoryId, {
                success: (
                    <FormattedMessage
                        id="Notification.download.recording.success"
                        defaultMessage="Your document download was successful"
                    />
                ),

                fail: (
                    <FormattedMessage
                        id="Notification.download.recording.fail"
                        defaultMessage="Your document download failed"
                    />
                ),
            })
        );
        onClose();
    }, [dispatch, applicationId, onClose, repositoryId, assetId, addonSystemKey, guideId]);

    const handleGenerateRecording = useCallback(() => {
        dispatch(
            generateRecordingOutputsRequest(guideId, {
                success: (
                    <FormattedMessage
                        id="Notification.generate.recording.success"
                        defaultMessage="Your document generation was successful. Please refresh your the page"
                    />
                ),

                fail: (
                    <FormattedMessage
                        id="Notification.generate.recording.fail"
                        defaultMessage="Your document generation failed"
                    />
                ),
            })
        );
        onClose();
    }, [dispatch, onClose, guideId]);

    return (
        <>
            {assetsArray.length > 0 && (
                <MenuItem id="yeself-menu-item" onClick={handleDownloadRecording}>
                    <FormattedMessage
                        id="Guides.menuItem.recording.download"
                        defaultMessage="Download"
                    />
                </MenuItem>
            )}

            {assetsArray.length === 0 && (
                <MenuItem id="yeself-menu-item" onClick={handleGenerateRecording}>
                    <FormattedMessage
                        id="Guides.menuItem.recording.generate"
                        defaultMessage="Generate"
                    />
                </MenuItem>
            )}
        </>
    );
};

export default GuideListItemRecordingMenuItems;
